import AContainer from "../library/ExtendedObjects/AContainer.js";
import InputHelper from "../library/InputHelper.js";
import Utils from "../library/Utils.js";
import MoneyBg from "./backgroundData/MoneyBg.js";

export default class Backgrounds extends AContainer
{
    constructor(scene)
    {
        super(scene, 0, 0);

        this.scene.add.existing(this);

        this.curImage = null;
        this.primaryImageKey = null;
        this.secondaryImageKey = null;

        InputHelper.Listen(InputHelper.KeyCodes.Q, ()=>{
            this.spawnNew(this.primaryImageKey);
            Utils.ManipulateObject(this.curImage, ()=>{this.logImageData();});
        });
        InputHelper.Listen(InputHelper.KeyCodes.E, ()=>{
            this.spawnNew(this.secondaryImageKey);
            Utils.ManipulateObject(this.curImage, ()=>{this.logImageData();});
        });
    }

    spawnNew(key)
    {
        let prevData = null;
        if (this.curImage) {
            prevData = {};
            prevData.scaleX = this.curImage.scaleX;
            prevData.scaleY = this.curImage.scaleY;
            prevData.angle = this.curImage.angle;
        }
        this.curImage = this.create(this.scene.mid.x, this.scene.mid.y, key);
        this.curImage.setPosition(this.scene.input.x, this.scene.input.y);
        if(prevData != null)
        {
            this.curImage.setScale(prevData.scaleX, prevData.scaleY);
            this.curImage.angle = prevData.angle;
        }
        this.logImageData();
    }

    addBaseBackground(color, animate)
    {
        let previousBG = this.curBG;
        this.curBG = this.scene.addRect(0, 0, this.scene.size.width, this.scene.size.height, color, this);
        if (animate) {
            this.curBG.alpha = 0;
            this.scene.addTween(this.curBG, 1000, { alpha: 1 }, Phaser.Math.Easing.Sine.Out, ()=>{
                if(previousBG != null) previousBG.destroy();
            });
        }
    }

    hideBG(bg)
    {
        let children = this.list.concat();
        children.splice(children.indexOf(this.curBG), 1);
        children.forEach((child)=>{bg.animateOut(child, this);});
    }

    displayBG(bg, animate)
    {
        this.addBaseBackground(bg.bgColor, animate);
        if(bg.tempBG) this.addtempBG(bg.tempBG);

        this.primaryImageKey = bg.primaryKey;
        this.secondaryImageKey = bg.secondaryKey;

        if(animate)
        {
            bg.data.forEach((data) => {bg.animateIn(data, this);});
        }
        else this.displayData(bg.data);
    }

    explodeData(imageData)
    {
        imageData.forEach((data)=>{
            let image = this.create(this.scene.mid.x, this.scene.mid.y, data.key);
            
            image.setScale(0);
            image.alpha = 0;
            image.setPosition(data.x, data.y);

            this.scene.addTween(image, 700, {scaleX: data.scale, scaleY: data.scale}, "Back");
            this.scene.addTween(image, 700, {alpha: 1, angle: data.angle}, Phaser.Math.Easing.Sine.Out);
        });
    }

    displayData(imageData)
    {
        imageData.forEach((data)=>{
            let image = this.create(data.x, data.y, data.key);
            image.setScale(data.scaleX, data.scaleY);
            image.angle = data.angle;
        });
    }

    addtempBG(key)
    {
        let tempBg = this.create(this.scene.mid.x, this.scene.mid.y, key);
        tempBg.alpha = .5;
    }

    logImageData()
    {
        //console.log("key: \"" + this.curImage.frame.name + "\",\nx: " + this.curImage.x + ", y: " + this.curImage.y + ",\nangle: " + this.curImage.angle +",\nscaleX: " + this.curImage.scaleX + ",\nscaleY: " + this.curImage.scaleY);
    }
    
    MixColors(color1, color2)
    {
        let col1= Phaser.Display.Color.IntegerToColor(color1);
        let col2 = Phaser.Display.Color.IntegerToColor(color2);
        let mixedCol = Phaser.Display.Color.ObjectToColor(Phaser.Display.Color.Interpolate.ColorWithColor(col1, col2, 1, .5)).color;
        return mixedCol;
    }
}